var GenericErrorCodes;
(function (GenericErrorCodes) {
    GenericErrorCodes["PBERRForbiddenInvalidToken"] = "PBERRForbiddenInvalidToken";
    GenericErrorCodes["PBERRForbiddenTokenExpired"] = "PBERRForbiddenTokenExpired";
    GenericErrorCodes["PBERRUnknownError"] = "PBERRUnknownError";
    GenericErrorCodes["PBERRConflict"] = "PBERRConflict";
    GenericErrorCodes["PBERRForbidden"] = "PBERRForbidden";
    GenericErrorCodes["PBERRMaintenance"] = "PBERRMaintenance";
    GenericErrorCodes["PBERRMFARequired"] = "PBERRMFARequired";
    /** @deprecated: Use 'PBAUTHMFAUserNotFound' */
    GenericErrorCodes["PBMFASetupRequired"] = "PBLOGMFASetupRequired";
    GenericErrorCodes["PBAUTHMFAUserNotFound"] = "PBAUTHMFAUserNotFound";
    GenericErrorCodes["PBERRTokenMissing"] = "PBERRTokenMissing";
    GenericErrorCodes["PBERRForbiddenNoPermission"] = "PBERRForbiddenNoPermission";
    GenericErrorCodes["PBERRForbiddenRestrictionCheckFailed"] = "PBERRForbiddenRestrictionCheckFailed";
})(GenericErrorCodes || (GenericErrorCodes = {}));
export default GenericErrorCodes;
